import {
  FETCH_PATIENTS_SUCCESS,
  FETCH_STARTED_PATIENTS_SUCCESS,
  GET_PATIENTS,
  HANDLE_REQUEST_CLOSE,
  HIDE_PATIENTS_LOADER,
  SHOW_PATIENTS_LOADER,
  ON_ADD_PATIENT,
  ON_PATIENT_CLOSE,
  ON_TOGGLE_DRAWER,
  SHOW_PATIENT_MESSAGE,
  SAVE_PATIENT_SUCCESS,
  ON_DELETE_PATIENT,
  ON_DELETE_PATIENT_CLOSE,
  DELETE_PATIENT_SUCCESS,
  FETCH_MORE_PATIENTS_SUCCESS,
  SHOW_MORE_PATIENTS_LOADER
} from 'constants/ActionTypes';

const INIT_STATE = {
  loader: true,
  alertMessage: '',
  showMessage: false,
  isErrorMessage: false,
  drawerState: false,
  noPatientsFoundMessage: 'patients.noPatientsFound',
  patientList: [],
  addPatientState: false,
  deletePatientState: false,
  selectedSectionId: 1,
  loadingMore: false,
  allLoaded: false
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_PATIENTS_SUCCESS: {
      return {
        ...state,
        patientList: action.payload,
        selectedSectionId: 1,
        loader: false,
        drawerState: false,
        allLoaded: false
      }
    }
    case SHOW_PATIENT_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload.message,
        isErrorMessage: action.payload.messageStatus,
        showMessage: true,
        loader: false
      }
    }
    case ON_ADD_PATIENT: {
      return { ...state, addPatientState: true };
    }
    case ON_PATIENT_CLOSE: {
      return { ...state, addPatientState: false };
    }
    case FETCH_STARTED_PATIENTS_SUCCESS: {
      return {
        ...state,
        loader: false,
        patientList: action.payload,
        selectedSectionId: 2,
        drawerState: false,
        allLoaded: false
      }
    }
    case GET_PATIENTS: {
      return {
        ...state,
        patientList: patientList
      }
    }
    case HANDLE_REQUEST_CLOSE: {
      return { 
        ...state, 
        showMessage: false, 
        isErrorMessage: false, 
        alertMessage: '' 
      }
    }
    case ON_TOGGLE_DRAWER: {
      return { ...state, drawerState: !state.drawerState }
    }
    case SHOW_PATIENTS_LOADER: {
      return { ...state, loader: true }
    }
    case HIDE_PATIENTS_LOADER: {
      return { ...state, loader: false }
    }
    case SAVE_PATIENT_SUCCESS: {
      let isNew = true;
      const patientList = state.patientList.filter((patient) => {
        if (patient.id === action.payload.id) {
          isNew = false;
          if (action.payload.isFavoriteRemoved) {
            return
          }
          return action.payload
        } else {
          return patient
        }
      });
      if (isNew) {
        patientList.push(action.payload);
      }

      return {
        ...state,
        alertMessage: isNew ? 'patients.successufullyAdded' : 'patients.successufullyUpdated',
        showMessage: true,
        patientList: patientList,
        loader: false
      }
    }
    case ON_DELETE_PATIENT: {
      return { ...state, deletePatientState: true }
    }
    case ON_DELETE_PATIENT_CLOSE: {
      return { ...state, deletePatientState: false }
    }
    case DELETE_PATIENT_SUCCESS: {
      const patientList = state.patientList.filter(function (patient) {
        return patient.id !== action.payload.id;
      });

      return {
        ...state,
        alertMessage: 'patients.successufullyDeleted',
        showMessage: true,
        patientList: patientList,
        loader: false
      }
    }
    case FETCH_MORE_PATIENTS_SUCCESS: {
      const patientList = state.patientList.concat(action.payload)

      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        patientList: patientList,
        loader: false,
        loadingMore: false,
        allLoaded: action.payload.length === 0 ? true : false
      }
    }
    case SHOW_MORE_PATIENTS_LOADER: {
      return {
        ...state,
        loadingMore: true
      }
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/Patients.js